<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<content-panel>
    @if(!isDetailOpen) {
        <panel-header
            heading="{{tableTitle}}"
            class="submission-list-header"
            [ngClass]="{'header-detailopen' : isDetailOpen}"
        >
        <button>
            <mat-icon
                class="date-range-icon"
                (click)="openDateRangeDialog()"
                >calendar_month</mat-icon>
        </button>
        </panel-header>
    } @else {
     <panel-header
        heading="{{tableTitleCollapsed}}"
        class="submission-list-header"
        [ngClass]="{'header-detailopen' : isDetailOpen}"
     >
     </panel-header>
    }

    <panel-body id="submissions-panel-body">
        <div class="container container-no-results">
            @if(dataSource.length === 0) {
                <div class="no-results-container"
                [ngClass]="{ 'split-view-no-results': isDetailOpen }">
                    <p class="no-results-message">No Records Found</p>
                </div>
            } @else if (!isDetailOpen) {
                <section>
                    <table 
                        mat-table
                        [dataSource]="dataSource">
                        <ng-container matColumnDef="serialNumber">
                            <th mat-header-cell *matHeaderCellDef class="column-center serial-styling">
                                <b>Serial #</b>
                            </th>
                            <td mat-cell *matCellDef="let element" class="column-center serial-styling">
                                {{element.SerialNumber}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="zoneName">
                            <th mat-header-cell *matHeaderCellDef class="column-center">
                                <b>Zone Name</b>
                            </th>
                            <td mat-cell *matCellDef="let element" class="column-center">
                                {{element.ZoneName}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="creationDate">
                            <th mat-header-cell *matHeaderCellDef class="column-center">
                                <b>Creation Date</b>
                            </th>
                            <td mat-cell *matCellDef="let element" class="column-center">
                                {{element.CreationDate | date: 'MM/dd/yyyy'}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef class="column-center">
                                <b>Status</b>
                            </th>
                            <td mat-cell *matCellDef="let element" class="column-center">
                                @if(element.Status === 'Complete') {
                                    <span class="chip-styling complete">
                                        {{element.Status}}
                                    </span>
                                } @else {
                                    <span class="chip-styling in-progress">
                                        {{element.Status}}
                                    </span>
                                }
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="defectCount">
                            <th mat-header-cell *matHeaderCellDef class="column-center">
                                <b>Defect Count</b>
                            </th>
                            <td mat-cell *matCellDef="let element" class="column-center">
                                {{element.DefectCount}}
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
                        <tr
                            mat-row
                            *matRowDef="let row; columns: tableColumns"
                            (click)="rowSelected(row.SerialNumber)"></tr>
                    </table>
                </section>
            } @else {
                @for(element of dataSource; track element.SerialNumber) {
                    <section
                        mat-ripple
                        class="list-row-container"
                        [ngClass]="activeSerial?.SerialNumber === element.SerialNumber ? 'active' : ''"
                        (click)="rowSelected(element.SerialNumber)"
                    >
                        <h2 class="primary-content-container">
                            {{element.SerialNumber}}
                        </h2>
                        <div class="secondary-content-container">
                            <div class="secondary-data-bold">Creation Date: </div> 
                            {{element.CreationDate | date: 'MM/dd/yyyy'}}
                        </div>
                        <div class="secondary-content-container">
                            <div class="secondary-data-bold">Status: </div> 
                            {{element.Status}}
                        </div>
                    </section>
                }
            }
        </div>
    </panel-body>
</content-panel>
